<template>
  <div class="carousel_wrap">
    <!-- <el-carousel  loop arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index"> -->
        <!-- 用视频替换图片 -->
        <video
          v-if="imgList[0].type === 'video'"
          :src="imgList[0].src"
          class="img_item"
          autoplay
          loop
          muted
          playsinline
          style="width: 100%;"
        ></video>
        <img v-else :src="imgList[0].src" alt="" class="img_item" />
        <!-- <div class="ho_top"></div> -->
        <!-- <img src="../../assets/home/homeTextNew.png" class="homeTextNew" /> -->
         <div  class="homeTextNew">
           <p style="white-space: nowrap;font-size: 24px;">具身智能系统与群体智能集群异构协同行业解决方案专家</p>
           <p style="font-size: 20px;" class="b-text"><span class="line"></span><span  style="white-space: nowrap;">「全空间无人体系智能装备行业领跑者」</span></p>
         </div>
        <div class="tips_font_title">
          <!-- <img src="../../asseFts/home/homeText.png" class="icLo" /> -->

          <!-- <h1>无人集群智能化解决方案专家</h1>
          <p>无人化、集群化、智能化——无人化系统与装备行业领跑者</p> -->
          <div v-if="showPoints" class="points_wrap">
            <!-- 修改为遍历对象数组，并添加点击事件 -->
            <div
              v-for="(point, index) in pointTexts"
              :key="index"
              class="point_item"
              :style="getRandomPosition(index)"
              @mouseenter="hoveredPointIndex = index"
              @mouseleave="hoveredPointIndex = null"
            >
              <img src="../../assets/home/pointLi.png" alt="point" />
              <div class="point_text">
                <template v-if="hoveredPointIndex === index">
                  <div class="point_desc">{{ point.desc }}</div>
                  <div class="point_links">
                    <a
                      v-for="(link, lidx) in point.links"
                      :key="lidx"
                      href="javascript:void(0)"
                      class="point_link"
                      @click="handleLinkClick(link)"
                      >{{ link.text }}</a
                    >
                  </div>
                </template>
                <template v-else>
                  {{ point.text }}
                </template>
              </div>
            </div>
          </div>
        </div>
      <!-- </el-carousel-item>
    </el-carousel> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
            //  src: require("../../assets/home/home_top.gif"),
          // 使用 require 引入 mp4 视频
          src: "https://hr2.chnsoft.com.cn/home_top.mp4",
          type: "video",
          line1: "产业大脑",
          line2: "赋能产业高质量发展",
        },
      ],
      // 修改为对象数组，包含desc和links
      pointTexts: [
        {
          text: "公司简介",
          desc: "公司简介",
          links: [{ text: "关于我们", path: "/about_us" }],
        },
        {
          text: "低空经济",
          path: "/security",
          id: 1,
          desc: "低空经济",
          links: [
            {
              text: "无人+公共安全",
              path: "/industry_application",
              query: { source: "industry_uav_safe", navUserCaseType: 1 },
            },
            {
              text: "无人+执法",
              path: "/industry_application",
              query: { source: "industry_safety_1", navUserCaseType: 1 },
            },
            {
              text: "无人+应急",
              path: "/industry_application",
              query: { source: "industry_safety_2", navUserCaseType: 1 },
            },
            {
              text: "无人+环保",
              path: "/industry_application",
              query: { source: "industry_other_4", navUserCaseType: 1 },
            },
            {
              text: "无人+森林",
              path: "/industry_application",
              query: { source: "industry_uav_forest", navUserCaseType: 1 },
            },
            {
              text: "无人+水利",
              path: "/industry_application",
              query: { source: "industry_uav_water", navUserCaseType: 1 },
            },
            {
              text: "无人+投送",
              path: "/industry_application",
              query: { source: "industry_uav_delivery", navUserCaseType: 1 },
            },
          ],
        },
        {
          text: "电网",
          id: 2,
          desc: "电网",
          links: [
            {
              text: "输电线路",
              path: "/industry_application",
              query: { source: "industry_power_1", navUserCaseType: 2 },
            },
            {
              text: "变电（换流）站",
              path: "/industry_application",
              query: { source: "industry_power_2", navUserCaseType: 2 },
            },
            {
              text: "配网",
              path: "/industry_application",
              query: { source: "industry_power_3", navUserCaseType: 2 },
            },
          ],
        },
        {
          text: "新能源",
          id: 3,
          desc: "新能源",
          links: [
            {
              text: "光伏发电",
              path: "/industry_application",
              query: { source: "industry_energy_1", navUserCaseType: 3 },
            },
            {
              text: "风力发电",
              path: "/industry_application",
              query: { source: "industry_energy_2", navUserCaseType: 3 },
            },
            {
              text: "抽水蓄能",
              path: "/industry_application",
              query: { source: "industry_energy_3", navUserCaseType: 3 },
            },
          ],
        },
        {
          text: "能源",
          id: 4,
          desc: "能源",
          links: [
            {
              text: "石油",
              path: "/industry_application",
              query: { source: "industry_energy_4", navUserCaseType: 4 },
            },
            {
              text: "天然气",
              path: "/industry_application",
              query: { source: "industry_energy_5", navUserCaseType: 4 },
            },
            {
              text: "管网",
              path: "/industry_application",
              query: { source: "industry_guan_wang", navUserCaseType: 4 },
            },
            {
              text: "矿业",
              path: "/industry_application",
              query: { source: "industry_other_3", navUserCaseType: 4 },
            },
          ],
        },
        {
          text: "轨道交通",
          id: 5,
          desc: "轨道交通",
          links: [
            {
              text: "公路",
              path: "/industry_application",
              query: { source: "industry_gong_lu", navUserCaseType: 5 },
            },
            {
              text: "铁路",
              path: "/industry_application",
              query: { source: "industry_tie_lu", navUserCaseType: 5 },
            },
            {
              text: "地铁",
              path: "/industry_application",
              query: { source: "industry_di_tie", navUserCaseType: 5 },
            },
          ],
        },
        {
          text: "其他",
          id: 6,
          desc: "其他",
          links: [
            {
              text: "边海防",
              path: "/industry_application",
              query: { source: "industry_other_2", navUserCaseType: 6 },
            },
            {
              text: "港口",
              path: "/industry_application",
              query: { source: "industry_other_5", navUserCaseType: 6 },
            },
            {
              text: "基础建设",
              path: "/industry_application",
              query: { source: "industry_other_6", navUserCaseType: 6 },
            },
            {
              text: "海洋",
              path: "/industry_application",
              query: { source: "industry_hai_yang", navUserCaseType: 6 },
            },
          ],
        },
      ],
      hoveredPointIndex: null,
      showPoints: false, // 新增
    };
  },
  mounted() {
    setTimeout(() => {
      this.showPoints = true;
    }, 600);
  },
  methods: {
    getRandomPosition(index) {
      // const top = Math.random() * 80 + 10; // 随机生成 10% 到 90% 的 top 值
      // const left = Math.random() * 80 + 10; // 随机生成 10% 到 90% 的 left 值
      let top = 0;
      let left = 0;
      switch (index) {
        case 0:
          top = 16;
          left = 53;
          break;
        case 1:
          top = 59;
          left = 63;
          break;
        case 2:
          top = 30;
          left = 78;
          break;
        case 4:
          top = 64;
          left = 27;
          break;
        case 3:
          top = 28;
          left = 28.5;
          break;
        case 5:
          top = 66;
          left = 48;
          break;
        case 6:
          top = 47;
          left = 76.5;
          break;
      }
      return {
        position: "absolute",
        top: `${top}%`,
        left: `${left}%`,
      };
    },
    // 新增点击处理方法
    handlePointClick(point) {
      if (point.text === "公司简介") {
        this.$router.push({ path: "/about_us" });
      } else {
        this.$router.push({
          path: "/all_user_cases",
          query: { source: "all_user_cases", navUserCaseType: point.id },
        });
      }
    },
    handleLinkClick(link) {
      // console.log("Link clicked:", link);
      if (link.path) {
        let text = link.text;
        if (text) {
          localStorage.setItem("selectedText", text);
          if (text == "海空协同无人船（艇）") {
            localStorage.setItem("TeDianBgProName", "水上智能航空站");
          } else if (text == "陆空协同无人消防车") {
            localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
          } else if (text == "算力服务器") {
            localStorage.setItem("TeDianBgProName", "ZF-C200 边缘计算终端");
          } else if (text == "机载板卡") {
            localStorage.setItem("TeDianBgProName", "ZF-A400 算力板卡");
          } else if (text == "系留供电装置") {
            localStorage.setItem(
              "TeDianBgProName",
              "系留供电装置"
            );
          } else if (text == "无人装备便携地面站") {
            localStorage.setItem("TeDianBgProName", "无人装备便携地面站");
          } else if (text == "机载任务系统") {
            localStorage.setItem(
              "TeDianBgProName",
              "AMS-400-V112 机载任务系统"
            );
          } else if (text == "无人装备驾控台") {
            localStorage.setItem("TeDianBgProName", "无人装备驾控台");
          } else if (text == "智能全域巡视系统") {
            localStorage.setItem("TeDianBgProName", "智能全域巡视系统");
          } else if (text == "全域电网巡检系统") {
            localStorage.setItem("TeDianBgProName", "全域电网巡检系统");
          } else {
            localStorage.setItem("TeDianBgProName", text);
          }
        }
        if (link.query) {
          // this.$router.push({ name: 'IndustryApplication', query:  { source: 'industry_uav_safe', navUserCaseType: 1 } });
          // { text: '无人+公共安全', path: '/industry_application', query: { source: 'industry_uav_safe', navUserCaseType: 1 } },
          this.$router.push({ path: link.path, query: link.query });
        } else {
          this.$router.push({ path: link.path });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ho_top {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  background: linear-gradient(
    180deg,
    rgba(28, 54, 93, 0.9) 0%,
    rgba(28, 54, 93, 0.3) 100%,
    rgba(28, 54, 93, 0) 100%
  );
}

.carousel_wrap {
  position: relative;
  overflow-x: hidden; /* 防止 100vw 导致横向滚动 */
  overflow-y: hidden; /* 防止垂直滚动条出现 */
  // .el-carousel__item {
  //   .img_item {
  //     width: 100vw !important;
  //     max-width: none;
  //     height: auto !important;
  //     position: relative;
  //     left: 50%;
  //     transform: translateX(-50%); /* 水平居中视口宽度的视频 */
  //     display: block;
  //   }

  //   img {
  //     width: 100%;
  //     height: auto;
  //     background-position: center;
  //     background-size: cover;
  //   }
  // }

  .homeTextNew {
    position: absolute;
    left: 32px;
    top: 100px;
    width: 60vh !important;
    // height: 74px !important;
    opacity: 1;
    font-family: PingFang TC;
    font-size: 24px;
    
    line-height: normal;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #1E242A;
    text-shadow: 1px -1px 0px rgba(161, 208, 255, 0.6);
    // text-align: center;
    line-height: 2;
    .b-text{
display: flex;
    justify-content: left;
    align-items: center;
      .line{
        display: inline-block;
        height: 4px;
        width: 60px;
        background: linear-gradient(90deg, rgba(30, 36, 42, 0) 0%, rgba(30, 36, 42, 0.12) 100%);
        margin-right: 10px;
        border-radius: 4px;
        vertical-align: middle;
      }
    }
  }

  .tips_font_title {
    // position: absolute;
    // top: 360px;
    // z-index: 5;
    // color: #fff;
    // font-size: 25px;
    // width: 100%;
    // text-align: center;
    // margin-top: 50px;
    // height: 218px;
        position: absolute;
    top: 0px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    width: 100%;
    text-align: center;
    margin-top: 80px;
    height: 100%;

    .icLo {
      width: 672px;
      height: auto;
      margin-bottom: 75px;
      margin-top: 20px;
    }

    p {
      opacity: 0.8;
      margin-top: 10px;
      font-family: PingFang TC;
      font-size: 20px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #ffffff;
    }

    .points_wrap {
      width: 100%;
      height: 100%;

      .point_item {
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
          margin-bottom: 0;
          position: absolute;
          top: 0px;
        }

        .point_text {
          margin-left: 38px;
          width: auto;
          border-radius: 15px;
          border: 1px solid #fff;
          background-color: #0f6bf6;
          color: #fff;
          display: flex;
          justify-content: left;
          align-items: left;
          font-size: 14px;
          padding: 8px 16px;
          flex-direction: column;
          min-width: 80px;
          min-height: 30px;
          max-width: 368px;

          .point_desc {
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            opacity: 0.8;
            padding-bottom: 8px;
            margin-bottom: 6px;
            border-bottom: rgba(255, 255, 255, 0.1) 1px solid;
          }

          .point_links {
            display: flex;
            flex-direction: row;
            gap: 8px;
            color: #fff;
            flex-wrap: wrap; // 新增：允许链接换行

            .point_link {
              font-size: 14px;
              color: #fff;
              text-decoration: none;
              border-bottom: 1px dashed transparent;
              transition: color 0.2s, border-bottom 0.2s;
              cursor: pointer;
              white-space: normal; // 新增：文本自动换行
            }

            .point_link:hover {
              color: #fff;
              font-weight: bold;
              border-bottom: 1px solid #fff;
            }
          }
        }
      }
    }
  }
}

::v-deep .el-carousel__button {
  display: none;
}
</style>
